(ns app.front.view.search.property
  "Properties tab of the global search page. Reuses the property search of the property dashboard,
   but takes the domain group scope and the search term from the shared search bar of the search
   page instead of having controls of its own."
  (:require [app.front.ui.results-tab-switcher :as ui-rts]
            [app.front.view.property.dashboard.widgets.search :as property-search]
            [app.front.view.search.mobile :as mobile]
            [app.front.view.search.subs :as subs]
            [core.front.event :refer [<sub >evt]]))

(defn- view-switcher [tr current-view]
  [ui-rts/results-tab-switcher
   {:tr           tr
    :tabs         [ui-rts/map-tab ui-rts/list-tab]
    :selected-tab current-view
    :on-select    #(>evt [::property-search/set-selected-view %])}])

(defn- results [tr]
  (let [current-view (<sub [::property-search/current-view])
        mobile?      (<sub [::subs/mobile?])
        map-view?    (= current-view :dashboard-search/map-view)]
    [:<>
     (when mobile?
       [:<>
        [mobile/toolbar tr]
        [:div.mb-6.w-full {:class "[&_button]:flex-1 [&_button]:justify-center"}
         [view-switcher tr current-view]]])
     [:div.flex.flex-wrap.justify-between.items-start.gap-4.mb-4
      (when-not mobile? [property-search/results-header tr])
      (when-not mobile?
        [view-switcher tr current-view])]
     (if map-view?
       [property-search/map-results tr]
       [property-search/result-table tr])]))

(defn panel
  [tr {:keys [save-button]}]
  [:<>
   (when-not (<sub [::subs/mobile?])
     [:div.hidden.md:block
      [:h2.mb-4.font-semibold (tr [:search/property-results])]
      [:div.border.border-solid.border-ui-gray.rounded.p-4
       [property-search/filter-controls tr]
       save-button]])
   [:div {:class (if (<sub [::subs/mobile?]) "mt-2" "mt-10")}
    [results tr]]])
